import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateDriverMutationVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
  userInput: Types.Users_Set_Input;
}>;


export type UpdateDriverMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number, display_name: string, email?: string | null, phone?: string | null, active: boolean, avatar_url?: string | null, updated_at: string, driver?: { __typename?: 'drivers', id: number, status: string, tax_class: string, driver_app_version?: string | null, phone_type?: string | null } | null }> } | null };


export const UpdateDriverDocument = gql`
    mutation UpdateDriver($driverId: bigint!, $userInput: users_set_input!) {
  update_users(where: {driver: {id: {_eq: $driverId}}}, _set: $userInput) {
    affected_rows
    returning {
      id
      display_name
      email
      phone
      active
      avatar_url
      updated_at
      driver {
        id
        status
        tax_class
        driver_app_version
        phone_type
      }
    }
  }
}
    `;
export type UpdateDriverMutationFn = Apollo.MutationFunction<UpdateDriverMutation, UpdateDriverMutationVariables>;

/**
 * __useUpdateDriverMutation__
 *
 * To run a mutation, you first call `useUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverMutation, { data, loading, error }] = useUpdateDriverMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverMutation, UpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverMutation, UpdateDriverMutationVariables>(UpdateDriverDocument, options);
      }
export type UpdateDriverMutationHookResult = ReturnType<typeof useUpdateDriverMutation>;
export type UpdateDriverMutationResult = Apollo.MutationResult<UpdateDriverMutation>;
export type UpdateDriverMutationOptions = Apollo.BaseMutationOptions<UpdateDriverMutation, UpdateDriverMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/updateDriver.mutation.gql}
 */
export async function updateDriver(
  variables: UpdateDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateDriverMutation['update_users']>
export async function updateDriver(
  variables: UpdateDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateDriverMutation>
export async function updateDriver(
  variables: UpdateDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateDriverMutation['update_users'] | UpdateDriverMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateDriverMutation>(
    UpdateDriverDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_users
}